import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { college } from '../../mock/data';

export default function FooterContact() {
  const phoneHref = `tel:${college.phone.replace(/\s/g, '')}`;
  return (
    <div>
      <h4 className="text-white font-semibold mb-4">Contact</h4>
      <ul className="space-y-3 text-sm">
        <li className="flex gap-3">
          <MapPin size={16} className="mt-0.5 shrink-0 text-blue-300" />
          <span>{college.address}</span>
        </li>
        <li className="flex gap-3 items-center">
          <Phone size={16} className="text-blue-300" />
          <a href={phoneHref} className="hover:text-white">{college.phone}</a>
        </li>
        <li className="flex gap-3 items-center">
          <Mail size={16} className="text-blue-300" />
          <a href={`mailto:${college.email}`} className="hover:text-white break-all">{college.email}</a>
        </li>
      </ul>
    </div>
  );
}
